import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, Dropdown, IconButton } from '@mui/joy';
import { NavMenu } from './NavMenu';
import { useEffect, useState } from 'react';
import { useChapterConfig } from '../../hooks/useChapterConfig';

export const NavButton = () => {
	//const theme = useTheme();
	const [open, setOpen] = useState(false);
	const [active, setActive] = useState(false);
	const { getEnabledChapters } = useChapterConfig();
	const numberOfChapters = getEnabledChapters().length;

	// Calculate drawer width based on number of chapters
	// Each chapter is 313px wide on desktop, 287px on mobile
	const desktopDrawerWidth = numberOfChapters * 313;
	const mobileDrawerWidth = 287;

	//theme.breakpoints.up('md');
	//theme.breakpoints.values.md;

	const toggleDrawer =
		(inOpen: boolean) => (event: KeyboardEvent | MouseEvent) => {
			if (
				event.type === 'keydown' &&
				((event as KeyboardEvent).key === 'Tab' ||
					(event as KeyboardEvent).key === 'Shift')
			) {
				return;
			}

			setOpen(inOpen);
		};

	useEffect(() => {
		if (open) {
			setTimeout(() => setActive(true), 200);
		} else {
			setActive(false);
		}
	}, [open]);

	return (
		<Dropdown>
			<IconButton
				variant='plain'
				onClick={() => setOpen(true)}
				sx={{ ':hover': { backgroundColor: 'transparent' }, color: '#000000' }}
			>
				<MenuIcon
					sx={{
						fontSize: '3rem',
						color: '#333333',
						':hover': { color: '#000000' }
					}}
				/>
			</IconButton>
			<Drawer
				open={open}
				onClose={toggleDrawer(false)}
				sx={{
					'--Drawer-horizontalSize': {
						xs: `${mobileDrawerWidth}px`,
						md: `min(100vw, ${desktopDrawerWidth}px)`
					},
					'.MuiDrawer-content': { backgroundColor: '#ffffff' }
				}}
			>
				<NavMenu isActive={active} />
			</Drawer>
		</Dropdown>
	);
};
